'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true,
})
exports.SemanticDateField = exports.PrintedDateField = exports.DateField = void 0

var _react = _interopRequireDefault(require('react'))

var _semanticUiReact = require('semantic-ui-react')

var _styledComponents = _interopRequireDefault(require('styled-components'))

var _conversion = require('../../utils/conversion.js')

var _index = require('../Flex/index.js')

var _index2 = require('../TextField/index.js')

var _templateObject, _templateObject2

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0)
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }))
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key]
          }
        }
      }
      return target
    }
  return _extends.apply(this, arguments)
}

var SemanticDateField = function SemanticDateField(_ref) {
  var fieldProps = _extends({}, _ref)

  return /*#__PURE__*/ _react['default'].createElement(
    _semanticUiReact.Form.Field,
    _extends(
      {
        type: 'date',
        control: _semanticUiReact.Input,
      },
      fieldProps
    )
  )
}

exports.SemanticDateField = SemanticDateField
var DateField = (0, _styledComponents['default'])(SemanticDateField)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteral([
      '\n  &&& {\n    input:focus {\n      border-color: ',
      ';\n    }\n  }\n',
    ])),
  function (props) {
    return props.theme.colors.primary
  }
)
exports.DateField = DateField
var FONT_SIZE_FACTOR = 6

var PrintedDateField = function PrintedDateField(_ref2) {
  var label = _ref2.label,
    value = _ref2.value
  var labelWidth = label.length * FONT_SIZE_FACTOR
  var minWidth = labelWidth + (0, _conversion.mmToPixel)(35)
  var year,
    month,
    day = ''

  if (value) {
    var splitDate = value.split('/')
    year = splitDate[0]
    month = splitDate[1]
    day = splitDate[2]
  }

  return /*#__PURE__*/ _react['default'].createElement(
    _index.Flex,
    {
      flex: '1',
      alignItems: 'center',
      margin: '8px 12px 0px 0px',
      minWidth: ''.concat(minWidth, 'px'),
    },
    /*#__PURE__*/ _react['default'].createElement(StyledLabel, null, label, ':'),
    /*#__PURE__*/ _react['default'].createElement(
      _index2.StyledValue,
      {
        flex: 1,
      },
      year
    ),
    '/',
    /*#__PURE__*/ _react['default'].createElement(
      _index2.StyledValue,
      {
        flex: 1,
      },
      month
    ),
    '/',
    /*#__PURE__*/ _react['default'].createElement(
      _index2.StyledValue,
      {
        flex: 1.5,
      },
      day
    )
  )
}

exports.PrintedDateField = PrintedDateField

var StyledLabel = _styledComponents['default'].span(
  _templateObject2 || (_templateObject2 = _taggedTemplateLiteral(['\n  padding-right: 4px;\n']))
)
